import { render, staticRenderFns } from "./InquiryView.vue?vue&type=template&id=e23376d0&scoped=true&"
import script from "./InquiryView.vue?vue&type=script&lang=js&"
export * from "./InquiryView.vue?vue&type=script&lang=js&"
import style0 from "./InquiryView.vue?vue&type=style&index=0&id=e23376d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23376d0",
  null
  
)

export default component.exports